export const props = [];
export const model = {
  // 修改密码对话框
  dialog:false,
  // user对象
  user:{
    loginPwd:''
  }
};
export const computed = {
  realName() {
    return window.localStorage.realName;
  }
};
